import React from "react";
import HeroSection from "@/components/home/HeroSection";
import IntroSection from "@/components/home/IntroSection";
import CategoryTilesSection from "@/components/home/CategoryTilesSection";
import HighlightsSection from "@/components/home/HighlightsSection";
import AgendaTeaserSection from "@/components/home/AgendaTeaserSection";
import OndernemersCTA from "@/components/home/OndernemersCTA";
import Seo from "@/components/Seo";
import { useLang } from "@/i18n/LangContext";
import { pageContent, pickLang } from "@/i18n/pageContent";

export const HomePage = () => {
  const { lang } = useLang();
  const c = pickLang(pageContent.home, lang).seo;
  return (
    <div data-testid="home-page">
      <Seo title={c.title} description={c.description} lang={lang} />
      <HeroSection />
      <IntroSection />
      <CategoryTilesSection />
      <HighlightsSection />
      <AgendaTeaserSection />
      <OndernemersCTA />
    </div>
  );
};

export default HomePage;
